// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './app/App';
import store from './app/store';
import './utils/sentry';
import 'braft-editor/dist/index.css';

// 解决安卓部分低端机事件透传问题
if (typeof MutationObserver === 'undefined') {
  document.addEventListener(
    'click',
    (event) => {
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }
      event.stopPropagation();
      event.preventDefault();
      return true;
    },
    true,
  );
  document.addEventListener(
    'mousedown',
    (event) => {
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return true;
      }
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }
      event.stopPropagation();
      event.preventDefault();
      return true;
    },
    true,
  );
}

// 解决ios safari 返回不刷新问题
const browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/; // 判断是否是苹果手机或iPad
if (browserRule.test(navigator.userAgent)) {
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      window.location.reload();
    }
  });
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
